import { gql } from '@apollo/client'

const ALLERGEN_QUERY = gql`
  query allergen($id: ID!) {
    allergen(id: $id) {
      id
      name
      description
      updatedAt
      updatedBy {
        id
        name
      }
      position
      includedAllergens {
        id
      }
      includedIngredients {
        id
      }
      synonyms
      isExcludedFromSearch
      imageUrl
    }
  }
`

export default ALLERGEN_QUERY
